<template>
    <div >
        <div class="flex bottom8">
            <el-select style="width: 145px" @change="changeCom" @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable filterable placeholder="请选择交易公司">
                <el-option
                        v-for="item in compsData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
            <!--<el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="small"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    range-separator="至"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>-->
            <el-input
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    placeholder="搜索"
                    v-model="vc_search">

            </el-input>
            <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>

            <el-button size="mini" :class="baseerp+'btn'" type="primary" @click="handleAdd">转入待开票</el-button>
        </div>
<!--        @selection-change="handleSelectionChange"-->
        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                border
                v-loading="loading"
                size="mini"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    type="index" :label="$t('form_serial_number')"

                    width="50">
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    label="客户">
            </el-table-column>
            <el-table-column
                    prop="vc_invoice_type"
                    label="发票类型"
                    show-overflow-tooltip>

            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    label="销售编号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_pz_invoicename"
                    label="开票品名"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_pzspecs"
                    label="规格型号"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
            width="55"
                    prop="vc_unit"
                    label="单位"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_price"
                    label="订单单价"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                    <div style="text-align: right">{{scope.row.f_price}}</div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="开单量/出库量/签收量"
                    show-overflow-tooltip
                    width="140">
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{scope.row.f_kdnum+'/'+scope.row.f_outnum+'/'+scope.row.f_signnum}}</span>
                </template>

            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="待开票量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="开票数量"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_amount"
                    label="开票金额"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                    <div style="text-align: right">{{scope.row.f_amount}}</div>
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="f_price_notax"
                    label="无税单价"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="f_amount_notax"
                    label="无税金额"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="f_sl"
                    label="税率"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="f_amount_tax"
                    label="税额"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_note"
                    label="发票备注"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_gsname"
                    label="销售方"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
            width="90"
                    prop="vc_kduname"
                    label="业务"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_lruname"
                    label="开单人"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_creditcode"
                    label="客户纳税人识别号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_adress"
                    label="地址、电话"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.vc_address+' '+scope.row.vc_tel }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="address"
                    label="开户行及帐号"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.vc_bank+' '+scope.row.vc_bank_account }}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_lruname"
                    label="申请人"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="dt_applytime"
                    label="申请时间"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="i_state"
                    label="开票状态"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="margin-left: 10px">{{ scope.row.i_state==0?'待提交':(scope.row.i_state==1?'已提交':'已开票') }}</span>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    prop="address"
                    label="开票时间"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_invoice_code"
                    label="发票代码"
                    show-overflow-tooltip>
            </el-table-column>-->
<!--            <el-table-column label="操作" width="100">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-button size="mini"-->
<!--                               type="primary"-->
<!--                               @click="handleAdd(scope.$index, scope.row)">转入待开票</el-button>-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>
        <div>
            <el-pagination
                    class="flex_e padT6"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pageSize"
                    layout="sizes, prev, pager, next"
                    :total="tableTotal">
            </el-pagination>
            <!--<div class="flex_b alc">
                <div>
                    {{'已选'+ ' '+multipleSelection.length+' '+'条'}}
                </div>
                <el-button :class="baseerp+'btn'"  size="small"  @click="sure">确定</el-button>
                &lt;!&ndash;<div class="flex alc">
                    <div class="marr4">
                        <div style="color: #9e9e9e;font-size: 12px">{{'开票总额'}}</div>
                        <div>{{totalPrice}}</div>
                    </div>
                    <el-button :class="baseerp+'btn'"  size="small" type="primary">确定</el-button>
                </div>&ndash;&gt;
            </div>-->
        </div>
        <!--dialog-->
        <el-dialog
                :class="baseerp+'div'"
                width="1000px"
                :title="title"
                :visible.sync="dialogVisible_add"
                :close-on-click-modal="false"
                @close="cancelDialog_add"
                v-if="dialogVisible_add"
                :append-to-body="true">
            <add-kp :addData="addData" @cancelDialog_add="cancelDialog_add"></add-kp>
        </el-dialog>
    </div>
</template>
<script>
    import {mapActions} from "vuex";

    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        data(){
            return{
                baseerp:"",
                mid:0,
                title:"新增开票",
                dialogVisible_add:false,
                addData:{},
                i_gsid:0,
                loading:true,
                vc_search:"",
                highlightCurrentRow:false,
                pageSize:20,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                tableData: [],
                multipleSelection: [],
                multipleSelection_2:[],
                tableHeight:0,
                compsData:[],
                companyName:'',
                companyId:0,
            }
        },

        mounted() {
            this.getCompanyList();

            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            this.baseerp=baseerp;
            // console.log('data',this.Data);
            this.getfMou();
            this.$nextTick(function () {
                this.onResize();
            });

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),

            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 160;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
            },
            //获取交易公司
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.mid,'this.m!!!!!!!!!')
                let param = {
                    vc_search:'',
                    page_count:1,
                    page_size:999,
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";

                }else if(type=='sou'){
                    this.vc_search=""
                }else if(type=='lx'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changeCom(e){
                // console.log(e);
                this.companyId=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changetype(e){
                // console.log(e);
                this.i_type=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            changeState(e){
                // console.log(e,'?????');
                this.i_state=e;
                if(this.i_state==0||this.i_state==1){
                    this.currentPage=1;
                    this.pageSize=999;
                    this.dt_startdate='';
                    this.dt_enddate='';
                    //this.getList();
                }else{
                    this.currentPage=1;
                    this.pageSize=30;
                    //this.getfMou();
                }
                this.$nextTick(()=>{
                    this.getfMou();
                })

            },
            handleAdd(){
                if(this.multipleSelection.length>0){
                    this.$confirm('是否继续转入待开票列表','提示',{
                        confirmButtonText:'继续',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(async()=>{
                        this.reset()
                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消'
                        })
                    })
                }else{
                    this.$message.warning('请选择发票数据')
                }

            },
            async reset(){
                this.loading=true;
                let param={
                    list:this.multipleSelection
                };
                var res = await API.reset(param);
                if (res.code==1){
                    this.$message.success(res.message)
                    this.currentPage=1
                    this.getList();

                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            cancelDialog_add(val){
                this.addData={};
                this.dialogVisible_add=false;
                if(val=='new'){
                    this.$emit('cancelDialog',val)
                }
            },
            uniqueByKey(arr, key) {
                let seen = new Set();
                return arr.filter((item) => {
                    let keyValue = item[key];
                    if (seen.has(keyValue)) {
                        return false;
                    } else {
                        seen.add(keyValue);
                        return true;
                    }
                });
            },
            sure(){
                /*console.log(this.multipleSelection,'this.multipleSelection');
                console.log(this.multipleSelection_2,'this.multipleSelection_2');
                let uniqueItems = this.uniqueByKey(this.multipleSelection_2, 'uniqueKey');
                console.log('uniqueItems',uniqueItems);
                this.$emit('cancelDialog',uniqueItems)*/
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },

            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading=true;
                /*let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }*/
                let param={
                    'i_mid':this.mid,
                    "i_gsid": this.companyId,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                };
                //return;
                //if(type==0){
                var res = await API.listAfterInvoice(param);
                //}else if(type==1){
                //    var res = await API.listTd(param);
                //}
                if (res.code==1){
                    /*res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })*/
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading=false;
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },



        },
    }
</script>

<style  lang="scss" scoped>
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }
    }
    .flex_e{
        display: flex;
        justify-content: end;
    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
    .bottom8{
        margin-bottom: 8px;
        margin-top: 8px;

    }



</style>
